module.exports = __webpack_public_path__ + "img/huanjing_logo.73c846db.3ce7dac3.jpg";